import * as actionTypes from "../../../constants/actionTypes";
import * as api from "../api";

export const setProvinces = (data) => {
    return {
        type: actionTypes.FETCH_PROVINCES,
        data: data,
    };
};

export const setCities = (data) => {
    return {
        type: actionTypes.FETCH_CITIES,
        data: data,
    };
};

export const setDistricts = (data) => {
    return {
        type: actionTypes.FETCH_DISTRICTS,
        data: data,
    };
};

export const setSubdistricts = (data) => {
    return {
        type: actionTypes.FETCH_SUBDISTRICTS,
        data: data,
    };
};

export const fetchProvinces = (query) => async (dispatch) => {
    try {
        const { result } = await api.getProvinceApi(query);
        dispatch(setProvinces(result));
    } catch (err) {
        console.error("Error fetching provinces:", err);
    }
};

export const fetchCities = (query) => async (dispatch) => {
    try {
        const { result } = await api.getCityApi(query);
        dispatch(setCities(result));
    } catch (err) {
        console.error("Error fetching cities:", err);
    }
};

export const fetchDistricts = (query) => async (dispatch) => {
    try {
        const { result } = await api.getDistrictApi(query);
        dispatch(setDistricts(result));
    } catch (err) {
        console.error("Error fetching districts:", err);
    }
};

export const fetchSubdistricts = (query) => async (dispatch) => {
    try {
        const { result } = await api.getSubDistrictApi(query);
        dispatch(setSubdistricts(result));
    } catch (err) {
        console.error("Error fetching subdistricts:", err);
    }
};

